import apiConfig from '../../../../../../../config/api'
import { apiRequestorHelper } from '../../../../../../../helpers'

const sendForm57Service = {
  sendFormC57: (id, obsCli) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/sendFormC57',
      method: 'post',
      body: {
        obsCli,
        clCliente: {
          id
        }
      }
    })
  }
}
export default sendForm57Service